<template>
  <div class="basic-layout">
    <SiteNavbar />
    <SiteContent />
    <SiteFooter class="site-footer" />
  </div>
</template>

<script>
import SiteNavbar from "@/layouts/components/siteNavbar.vue";
import SiteContent from "@/layouts/components/siteContent.vue";
import SiteFooter from "@/layouts/components/siteFooter.vue";
export default {
  name: "DefaultLayout",
  components: {
    SiteContent,
    SiteNavbar,
    SiteFooter
  }
};
</script>
